// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateNigerianBankCode(selectedPaymentMethod: string, selectedEwallet: string, bankCodeValue: string): ?UserInputValidationError {
  if (
    selectedPaymentMethod === 'ewallet'
    && selectedEwallet === 'ussd'
    && (bankCodeValue === '' || bankCodeValue === null || bankCodeValue === undefined)
  ) {
    return {id: 'empty'};
  }
}
